module.exports = __webpack_public_path__ + "static/media/recording.f5d362c2.jpg";